import { render, staticRenderFns } from "./compayInfo.vue?vue&type=template&id=bf9f06be"
import script from "./compayInfo.vue?vue&type=script&lang=js"
export * from "./compayInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports